module.exports = __webpack_public_path__ + "static/greetings-e676b83f1aeb81b09132cf8cb2428dd4.png";